import { HStack, Stack, Text } from '@chakra-ui/react';
import { getNearestAirportDistancesMi } from '@pelicargo/utils';
import { useMemo } from 'react';

import { trpc } from '../../config/trpc';
import { Airports } from '../../utils/types';
import { LabeledText } from '../LabeledText';

const LOCAL_TRUCKER_DISTANCE_MI = 50;

type Props = {
  zipCode?: string | null;
  country?: string;
  originAirports?: Airports;
};

export const PickupAirportDistances = ({ zipCode, country, originAirports }: Props) => {
  const { data: zip_latlng } = trpc.getPostalCodeLocation.useQuery(
    { code: zipCode ?? undefined, country: country ?? 'US' },
    { enabled: !!zipCode },
  );

  const distances = useMemo(() => {
    const lat = zip_latlng?.lat;
    const lon = zip_latlng?.lon;
    if (!Number.isFinite(lat) || !Number.isFinite(lon) || !originAirports?.length) return [];

    return getNearestAirportDistancesMi({ latitude: lat, longitude: lon }, originAirports);
  }, [zip_latlng, originAirports]);

  if (!zipCode || !distances.length) return null;

  return (
    <Stack flex={1} spacing={0} py={1} px={2}>
      <LabeledText
        label="Distance from pickup"
        isHorizontal
        value={
          <HStack spacing={1} flexWrap="wrap">
            {distances.map(({ id, distanceMi }, index) => (
              <Text
                key={id}
                fontSize="sm"
                fontWeight="600"
                color={distanceMi < LOCAL_TRUCKER_DISTANCE_MI ? 'green.600' : undefined}
              >
                {`${id}: ${Math.round(distanceMi)} mi${index < distances.length - 1 ? ' ·' : ''}`}
              </Text>
            ))}
          </HStack>
        }
      />
    </Stack>
  );
};
